import React, { useMemo, useRef } from 'react';

import { PrePlayerModalStep } from '../../datasource/generated';

interface PrePlayerAnimationVideoProps {
    src: string;
    playCount?: number | null;
    endOnLastFrame?: boolean;
}

export function normalizePlayCount(playCount?: number | null) {
    if (!Number.isFinite(playCount) || !playCount || playCount < 1) return 1;
    return Math.max(1, Math.trunc(playCount));
}

export function selectPrePlayerVideo(animation: PrePlayerModalStep | undefined, isXs: boolean) {
    if (!animation) return undefined;

    if (isXs && animation.webXsVideoUrl) {
        return {
            src: animation.webXsVideoUrl,
            playCount: animation.webXsLoopCount,
            endOnLastFrame: animation.webXsEndOnLastFrame,
        };
    }

    if (!animation.webVideoUrl) return undefined;
    return {
        src: animation.webVideoUrl,
        playCount: animation.webLoopCount,
        endOnLastFrame: animation.webEndOnLastFrame,
    };
}

export const PrePlayerAnimationVideo = ({
    src,
    playCount,
    endOnLastFrame = false,
}: PrePlayerAnimationVideoProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const completedPlays = useRef(0);
    const totalPlayCount = useMemo(() => normalizePlayCount(playCount), [playCount]);

    const handleEnded = () => {
        const video = videoRef.current;
        if (!video) return;

        completedPlays.current += 1;
        if (completedPlays.current < totalPlayCount) {
            video.currentTime = 0;
            void video.play().catch(() => undefined);
            return;
        }

        if (!endOnLastFrame) {
            video.currentTime = 0;
            video.pause();
        }
    };

    return (
        <video
            ref={videoRef}
            className='tutorial-modal__content__video'
            src={src}
            autoPlay
            muted
            playsInline
            preload='auto'
            aria-hidden='true'
            onEnded={handleEnded}
        />
    );
};

export default PrePlayerAnimationVideo;
